import { HeroComponent } from "../../components/hero-component/HeroComponent";
import React from "react";

function LoginPage() {
    return <HeroComponent />;
}

export default LoginPage;
